import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HandymanIcon from '@mui/icons-material/Handyman';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import { useNavigate } from 'react-router-dom';
import { CategoriesButton } from './CategoriesButton';
import { Dispatch, SetStateAction } from 'react';
import { ProductCategory } from '../../constants/products';
import BuildIcon from '@mui/icons-material/Build';


export interface CategoriesProps {
    closeMobileMenu?: () => void;
    setFilterOptions?: Dispatch<SetStateAction<string[] | undefined>>;}


export const Categories: React.FC<CategoriesProps> = ({ closeMobileMenu, setFilterOptions }) => {

    const navigate = useNavigate();

    return (
        <div className="flex flex-row flex-wrap gap-4 lg:gap-7 mt-3 justify-center">
            <CategoriesButton data={{value: ProductCategory.TRANSPORTATION, label: "Sõidukid ja haagised"}} closeMobileMenu={closeMobileMenu}
                icon={<DirectionsCarIcon style={{ color: '#333', width: "40px", height: "40px" }}  />}
            />
            <CategoriesButton data={{value: ProductCategory.TOOLS, label: "Tööriistad"}} closeMobileMenu={closeMobileMenu}
                icon={<HandymanIcon style={{ color: '#333', width: "40px", height: "40px" }} />}
            />
            <CategoriesButton data={{value: ProductCategory.DEVICES, label: "Seadmed ja tehnika"}} closeMobileMenu={closeMobileMenu}
                icon={<CameraAltIcon style={{ color: '#333', width: "40px", height: "40px" }} />}
            />
            <CategoriesButton data={{value: ProductCategory.REALESTATE, label: "Kinnisvara"}} closeMobileMenu={closeMobileMenu}
                icon={<MapsHomeWorkIcon style={{ color: '#333', width: "40px", height: "40px" }} />}
            />
            <CategoriesButton data={{value: ProductCategory.SERVICES, label: "Teenused"}} closeMobileMenu={closeMobileMenu}
                icon={<BuildIcon style={{ color: '#333', width: "40px", height: "40px" }} />}
            />
        </div>
    )
}

